import { useThemeContext } from "../../context/ThemeContext";
import { SectionDivider } from "../../components/SectionDivider/SectionDivider";

import { Hero } from "../../components/Hero/Hero";
import { AboutGrid } from "../../components/Grid/AboutGrid/AboutGrid";
// import { ProjectGrid } from "../../components/Grid/ProjectGrid/ProjectGrid";
// import { NotesGrid } from "../../components/Grid/NotesGrid/NotesGrid";

export function HomePage() {
  const theme = useThemeContext();

  return (
    <>
      <Hero />

      <SectionDivider theme={theme} label="01 · about" />
      <AboutGrid />

      {/*
      <SectionDivider theme={theme} label="02 · selected work" />
      <ProjectGrid />

      <SectionDivider theme={theme} label="03 · recent notes" />
      <NotesGrid />
      */}
    </>
  );
}
